//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment-business-days';
import wysiwyg from 'vue-wysiwyg';
import DatePicker from 'vue2-datepicker';
import Multiselect from 'vue-multiselect';
import FieldsValuation from './FieldsValuation';
export default {
  props: {
    appraisers: {
      type: Array,
      default: () => []
    },
    products: {
      type: Array,
      default: () => []
    },
    company: {
      type: Object,
      default: null
    },
    detail: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    isAdmin: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'detail.data.product': function (value) {
      this.detail.data.eta = null;
      this.detail.data.tat = null;
      this.detail.data.cercla = null;
      this.detail.data.lien = null;
      this.detail.data.sba = null;
      this.detail.data.roofFlag = this.hasRoofFlag;
      this.detail.data.appraisers = [];
      this.detail.data.valuationFlag = this.hasValuationFlag;
      this.detail.data.sub_products_selected = []; // Pre-select "standard" if available.

      if (value.standard && parseInt(value.standard)) {
        this.detail.data.tat = 'standard';
      }

      this.updateETA(this.detail.data.tat);
    },
    'detail.data.tat': function (value) {
      this.updateETA(value);
    },

    hasValuationFlag(newValue, oldValue) {
      if (oldValue) {
        this.detail.data.complexity = null;
        this.detail.data.propertyType = null;
        this.detail.data.transactionType = null;
        this.detail.data.transactionTypeOther = null;
        this.detail.data.transactionAmount = null;
        this.detail.data.interestAppraised = null;
        this.detail.data.interestAppraisedOther = null;
      }
    }

  },
  methods: {
    updateETA(tat) {
      if (tat && this.detail && this.detail.data.product) {
        const days = parseInt(this.detail.data.product[tat]);

        if (days) {
          const eta = moment().businessAdd(days);
          this.detail.data.eta = eta.format('YYYY-MM-DD');
        }
      }
    }

  },
  computed: {
    isEvansBankAppraisal() {
      if (!(this.detail && this.detail.data.product)) {
        return false;
      }

      return this.detail.data.product.id === '2648216805';
    },

    isFirstDrawInspection() {
      if (!(this.detail && this.detail.data.product)) {
        return false;
      }

      return this.detail.data.product.id === '1590978800';
    },

    isNextDrawInspection() {
      if (!(this.detail && this.detail.data.product)) {
        return false;
      }

      return this.detail.data.product.id === '1798415950';
    },

    canSelectAppraisers() {
      return this.company && this.company.appraiser_status === 'Choose From Above Appraisers';
    },

    hasCerclaFlag() {
      if (!this.detail || !this.detail.data.product) {
        return false;
      }

      return this.detail.data.product.cercla_protection_flag === 'Yes';
    },

    hasLienFlag() {
      if (!this.detail || !this.detail.data.product) {
        return false;
      }

      return this.detail.data.product.lien_search_flag === 'Yes';
    },

    hasSbaFlag() {
      if (!this.detail || !this.detail.data.product) {
        return false;
      }

      return this.detail.data.product.sba_loan_flag === 'Yes';
    },

    hasRoofFlag() {
      if (!this.detail || !this.detail.data.product) {
        return false;
      }

      return this.detail.data.product.roof_flag === 'Yes';
    },

    hasValuationFlag() {
      if (!this.detail || !this.detail.data.product) {
        return false;
      }

      return this.detail.data.product.valuation_flag === 'Yes';
    },

    departments() {
      return this.products.filter(department => department.products && department.products.length);
    },

    tats() {
      if (!this.detail || !this.detail.data.product) {
        return [];
      }

      const choices = [];

      if (this.detail.data.product.standard && parseInt(this.detail.data.product.standard)) {
        choices.push({
          value: 'standard',
          text: `Standard (${parseInt(this.detail.data.product.standard)} business days)`
        });
      }

      if (this.detail.data.product.rush && parseInt(this.detail.data.product.rush)) {
        choices.push({
          value: 'rush',
          text: `Rush (${parseInt(this.detail.data.product.rush)} business days)`
        });
      }

      if (this.detail.data.product.super_rush && parseInt(this.detail.data.product.super_rush)) {
        choices.push({
          value: 'super_rush',
          text: `Super Rush (${parseInt(this.detail.data.product.super_rush)} business days)`
        });
      }

      if (!choices.length) {
        choices.push({
          value: 'proposal_required',
          text: 'Proposal Required'
        }); // Set this as the default.

        this.$nextTick(() => {
          this.detail.data.tat = 'proposal_required';
        });
      }

      return choices;
    },

    fees: {
      get() {
        if (this.detail.data.fees) {
          return this.detail.data.fees;
        }

        return null;
      },

      set(value) {
        this.detail.data.fees = value;
      }

    },
    eta: {
      get() {
        if (this.detail.data.eta) {
          return this.detail.data.eta;
        }

        return null;
      },

      set(value) {
        this.detail.data.eta = value;
      }

    }
  },
  components: {
    'wysiqyg': wysiwyg,
    DatePicker,
    Multiselect,
    FieldsValuation
  }
};